export default {"src":"/_next/static/media/ftm.af71a88f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};